import { rgbaToHex } from "../Color";

export function parseStyle(node) {
    if (!node?.style) return [];
    const styleChild = [];
    let computedStyle = node.style;
    try {
        computedStyle = window.getComputedStyle(node);
    } catch (error) {
        console.warn(error, node);
    }
    if(node.style.cssText) {
        node.style.cssText.split(";").forEach((style) => {
            if (style) {
                let [key, value] = style.split(":");
                key = key.trim();
                value = value.trim();
                if (value) switch(key) {
                    case "font-weight":
                        const fontWeight = parseInt(value);
                        if (isNaN(fontWeight)) {
                            if (value === "bold") styleChild.push({tag: "w:b" });
                            else if (value === "bolder") styleChild.push({tag: "w:bCs"});
                        } else if(fontWeight >= 700) styleChild.push({tag: "w:b"});
                        break;
                    case "font-style":
                        if (value === "italic") styleChild.push({tag: "w:i" });
                        break;
                    case "text-decoration":
                        value.split(" ").forEach((decoration) => {
                            switch (decoration.trim()) {
                                case "underline":
                                    styleChild.push({attrs: {"w:val": "single"}, tag: "w:u"});
                                    break;
                                case "line-through":
                                    styleChild.push({attrs: {"w:val": "strike"}, tag: "w:strike"});
                                    break;
                                case "overline":
                                    styleChild.push({attrs: {"w:val": "overline"}, tag: "w:u"});
                                    break;
                                default:
                                    break;
                            }
                        });
                        break;
                    case "text-align":
                        styleChild.push({attrs: {"w:val": value}, tag: "w:jc"});
                        break;
                    case "color":
                        styleChild.push({attrs: {"w:val": rgbaToHex(value)}, tag: "w:color"});
                        break;
                    case "background-color":
                        styleChild.push({attrs: {"w:val": "clear", "w:color": "auto", "w:fill": rgbaToHex(value) || "#ffffff00"}, tag: "w:shd"});
                        break;
                    case "font-size":
                        const fontSize = Math.round(parseFloat(computedStyle.fontSize) * 1.5);
                        if (!isNaN(fontSize)) styleChild.push({attrs: {"w:val": fontSize + ""}, tag: "w:sz"});
                        break;
                    case "font-family":
                        let fontFamily = value? value.split(",")[0] : "";
                        if (fontFamily) fontFamily = fontFamily.trim().replace(/['"]+/g, '');
                        if (fontFamily) styleChild.push({attrs: {"w:val": fontFamily}, tag: "w:rFonts"});
                        break;
                    case "line-height":
                        styleChild.push({attrs: {"w:val": value}, tag: "w:spacing"});
                        break;
                    default:
                        break;
                }
            }
        });
    }

    return styleChild;  
}